module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Tabs/images/overlay.9e7d0603.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Tabs/images/overlay.png
// module id = 2754
// module chunks = 11